import dynamic from "next/dynamic";

export const DynamicLayoutWidget015 = dynamic(
  () => import("./LayoutWidget015"),
  {
    suspense: true,
  }
);
